import { Component, OnDestroy, OnInit } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PageSlotModule } from '@spartacus/storefront';

import { SdSpyTargetDirective } from '@seb/web-design-system/core';

@Component({
  selector: 'wc-footer',
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [
    SdSpyTargetDirective,
    PageSlotModule
  ]
})
export class FooterComponent implements OnInit, OnDestroy {
  protected readonly destroy$: Subject<void> = new Subject();

  isSimplified = false;

  constructor(private cmsService: CmsService) {}

  ngOnInit(): void {
    this.cmsService
      .getCurrentPage()
      .pipe(
        filter((page) => !!page),
        takeUntil(this.destroy$)
      )
      .subscribe((page) => {
        this.isSimplified =
          page.label?.startsWith('/checkout') ||
          page.label?.startsWith('/cart') ||
          page.label?.startsWith('/donations') ||
          page.label?.startsWith('/order-confirmation') ||
          page.label?.startsWith('/received-order-confirmation') ||
          page.label?.startsWith('/checkout/express/review');
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
